import { createSelector } from '@ngrx/store';
import { selectUtilData, selectUtilUi } from '../utils.selectors';
import { RbacUserPermissions } from '../../../../../common/models/rbac.interface';

export const selectAppLoading = createSelector(
    selectUtilUi,
    (ui) => ui.loading ?? false
);

export const selectRbacUserPermissions = createSelector(
    selectUtilData,
    (data) => data.rbacPermissions ?? ({} as RbacUserPermissions)
);

export const selectUserPermissionsExist = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => {
        return Object.keys(rbacPermissions)?.length > 0;
    }
);

export const selectRbacIsSuperUser = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_super_user ?? false
);

export const selectRbacIsInternalUser = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_internal_user ?? false
);

export const selectRbacIsManualRedeemAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_manual_redeem_allowed ?? false
);

export const selectRbacCanChangeAccountStatus = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_account_status_change_allowed ?? false
);

export const selectRbacIsFraudAnalysisAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_ss_fraud_analysis_allowed
);

export const selectRbacIsAssignOffersAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_ss_associate_offers_allowed ?? false
);

export const selectRbacIsActivateOffersAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_ss_activate_offers_allowed ?? false
);

export const selectRbacIsTransactionViewAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_ss_transaction_view_allowed ?? false
);

export const selectRbacIsTransactionViewAllPartnersAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_transaction_view_all_partners_allowed ?? false
);

export const selectRbacIsDuplicateTransactionViewAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_duplicate_transaction_view_allowed ?? false
);

export const selectRbacIsUserAccountViewAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_user_account_view_allowed ?? false
);

export const selectRbacIsEditShopperInfoAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_user_account_modification_allowed ?? false
);

export const selectRbacIsOfferViewAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_ss_offer_view_allowed ?? false
);

export const selectRbacIsViewPaymentHistoryAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_view_payment_history_allowed ?? false
);

export const selectRbacIsReprocessPaymentAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_reprocess_payment_allowed ?? false
);

export const selectRbacIsContinuityAdjustmentAllowed = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_continuity_adjustment_allowed ?? false
);

export const selectRbacCanViewPaymentReviewTab = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_payment_review_allowed
);

export const selectRbacCanViewTransactionReviewTab = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_transaction_review_allowed
);

export const selectRbacCanViewOfferReviewTab = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_offer_review_allowed
);

export const selectRbacCanDeactivateShopper = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) =>
        rbacPermissions.is_ss_user_deactivation_allowed ?? false
);

export const selectRbacCanViewAuditTrailTab = createSelector(
    selectRbacUserPermissions,
    (rbacPermissions) => rbacPermissions.is_audit_trail_view_allowed
);
